<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <mtc-form-item label="label.languageDescription" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['langText']" :placeholder="$t('label.pleaseEnterLanguageDescription')"></a-input>
        </mtc-form-item>
        <mtc-form-item label="label.associatedBusinessType" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            :triggerChange="true"
            dictCode="language_type"
            v-decorator="['relBizType', validatorRules.relBizType]"
          />
        </mtc-form-item>
        <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.associatedDatabaseTable">
          <a-select
            v-decorator="['relTable']"
            @change="tableNameChange"
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option v-for="item in tableNameList" :key="item.tableName" :value="item.tableName">
              {{ item.tableName }}
            </a-select-option>
          </a-select>
        </mtc-form-item>
        <mtc-form-item label="label.associatedDataField" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="['relField']"
            @change="relFieldChange"
            :disabled="!model.tableName"
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option v-for="item in relFieldList" :key="item.columnName" :value="item.columnName">
              {{ item.columnName }}
            </a-select-option>
          </a-select>
        </mtc-form-item>
        <mtc-form-item label="label.associatedEntityField" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['relEntityAttribute']" :placeholder="$t('label.associatedEntityField')"></a-input>
        </mtc-form-item>
        <!--<a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
          <!--<a-radio-group v-decorator="['validFlag', { initialValue: 'Y' }]">-->
            <!--<a-radio value="Y">是</a-radio>-->
            <!--<a-radio value="N">否</a-radio>-->
          <!--</a-radio-group>-->
        <!--</a-form-item>-->
        <mtc-form-item label="label.whetherValid" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            v-decorator="['validFlag', {}]"
            :placeholder="$t('label.pleaseSelectWhetherSynchronizeWorkflowEngine')"
            :type="'radio'"
            :triggerChange="true"
            dictCode="valid_flag"
          />
        </mtc-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JDate from '@/components/jeecg/JDate'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysLanguageModal',
  components: {
    JDate,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: `${MTC_AUTH}system/sysLanguageDisposition/add`,
        edit: `${MTC_AUTH}system/sysLanguageDisposition/edit`,
        getAllTableName: `${MTC_AUTH}system/sysLanguage/queryAllTableName`,
        queryColumnByTableName: `${MTC_AUTH}system/sysLanguage/queryColumnByTableName`,
      },
      tableNameList: [],
      relFieldList: [],
    }
  },
  created() {
    getAction(this.url.getAllTableName).then((res) => {
      this.tableNameList = res.result
    })
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'langType',
            'langText',
            'relBizType',
            'relTable',
            'relField',
            'relEntityAttribute',
            'relBizId',
            'createBy',
            'createTime',
            'updateBy',
            'updateTime',
            'sysOrgCode',
            'notes',
            'validFlag',
            'delFlag',
            'tenantCode'
          )
        )
      })
    },
    close() {
      this.$emit('close')
      this.relFieldList = []
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'langType',
          'langText',
          'relBizType',
          'relTable',
          'relField',
          'relEntityAttribute',
          'relBizId',
          'createBy',
          'createTime',
          'updateBy',
          'updateTime',
          'sysOrgCode',
          'notes',
          'validFlag',
          'delFlag',
          'tenantCode'
        )
      )
    },
    // 关联表change事件
    tableNameChange(e) {
      let _request = {
        tableName: e,
      }
      this.model.tableName = e
      this.model.relField = ''
      this.form.setFieldsValue(pick(this.model, 'tableName', 'relField'))
      this.relFieldList = []
      getAction(this.url.queryColumnByTableName, _request).then((res) => {
        this.relFieldList = res.result
      })
    },
    relFieldChange(e) {
      this.model.relEntityAttribute = this.formatRelField(e)
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'relEntityAttribute'))
      })
    },
    formatRelField(val) {
      var strArr = val.split('_')
      var result = strArr[0]
      for (var i = 1; i < strArr.length; i++) {
        result = result + strArr[i].slice(0, 1).toUpperCase() + strArr[i].slice(1)
      }
      return result
    },
  },
}
</script>